
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-8i8exb",
"minContentWidth": "--awsui-min-content-width-8i8exb",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-8i8exb",
"contentGapLeft": "--awsui-content-gap-left-8i8exb",
"contentGapRight": "--awsui-content-gap-right-8i8exb",
"contentHeight": "--awsui-content-height-8i8exb",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-8i8exb",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-8i8exb",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-8i8exb",
"defaultMaxContentWidth": "--awsui-default-max-content-width-8i8exb",
"defaultMinContentWidth": "--awsui-default-min-content-width-8i8exb",
"drawerSize": "--awsui-drawer-size-8i8exb",
"drawerMinSize": "--awsui-drawer-min-size-8i8exb",
"bottomDrawerSize": "--awsui-bottom-drawer-size-8i8exb",
"footerHeight": "--awsui-footer-height-8i8exb",
"headerGap": "--awsui-header-gap-8i8exb",
"headerHeight": "--awsui-header-height-8i8exb",
"layoutWidth": "--awsui-layout-width-8i8exb",
"mainGap": "--awsui-main-gap-8i8exb",
"mainOffsetLeft": "--awsui-main-offset-left-8i8exb",
"mainTemplateRows": "--awsui-main-template-rows-8i8exb",
"mobileBarHeight": "--awsui-mobile-bar-height-8i8exb",
"notificationsHeight": "--awsui-notifications-height-8i8exb",
"offsetTop": "--awsui-offset-top-8i8exb",
"overlapHeight": "--awsui-overlap-height-8i8exb",
"navigationWidth": "--awsui-navigation-width-8i8exb",
"navigationCollapsedWidth": "--awsui-navigation-collapsed-width-8i8exb",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-8i8exb",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-8i8exb",
"splitPanelHeight": "--awsui-split-panel-height-8i8exb",
"splitPanelMinWidth": "--awsui-split-panel-min-width-8i8exb",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-8i8exb",
"toolsMaxWidth": "--awsui-tools-max-width-8i8exb",
"toolsWidth": "--awsui-tools-width-8i8exb",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-8i8exb",
"contentScrollMargin": "--awsui-content-scroll-margin-8i8exb",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-8i8exb",
"flashbarStackIndex": "--awsui-flashbar-stack-index-8i8exb",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-8i8exb",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-8i8exb",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-8i8exb",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-8i8exb",
"dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-8i8exb",
"dropdownContentBorderColor": "--awsui-dropdown-content-border-color-8i8exb",
"dropdownContentBorderWidth": "--awsui-dropdown-content-border-width-8i8exb",
"dropdownContentBorderRadius": "--awsui-dropdown-content-border-radius-8i8exb",
"modalCustomWidth": "--awsui-modal-custom-width-8i8exb",
"modalCustomHeight": "--awsui-modal-custom-height-8i8exb",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-8i8exb",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-8i8exb",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-8i8exb",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-8i8exb",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-8i8exb",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-8i8exb",
"sliderLabelCount": "--awsui-slider-label-count-8i8exb",
"sliderTickCount": "--awsui-slider-tick-count-8i8exb",
"sliderReferenceColumn": "--awsui-slider-reference-column-8i8exb",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-8i8exb",
"sliderMaxStart": "--awsui-slider-max-start-8i8exb",
"sliderMinEnd": "--awsui-slider-min-end-8i8exb",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-8i8exb",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-8i8exb",
"togglesLeftWidth": "--awsui-toggles-left-width-8i8exb",
"togglesRightWidth": "--awsui-toggles-right-width-8i8exb",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-8i8exb",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-8i8exb",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-8i8exb",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-8i8exb",
"styleBackgroundActive": "--awsui-style-background-active-8i8exb",
"styleBackgroundDefault": "--awsui-style-background-default-8i8exb",
"styleBackgroundDisabled": "--awsui-style-background-disabled-8i8exb",
"styleBackgroundHover": "--awsui-style-background-hover-8i8exb",
"styleBorderColorActive": "--awsui-style-border-color-active-8i8exb",
"styleBorderColorDefault": "--awsui-style-border-color-default-8i8exb",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-8i8exb",
"styleBorderColorHover": "--awsui-style-border-color-hover-8i8exb",
"styleColorActive": "--awsui-style-color-active-8i8exb",
"styleColorDefault": "--awsui-style-color-default-8i8exb",
"styleColorDisabled": "--awsui-style-color-disabled-8i8exb",
"styleColorHover": "--awsui-style-color-hover-8i8exb",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-8i8exb",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-8i8exb",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-8i8exb",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-8i8exb",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-8i8exb",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-8i8exb",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-8i8exb",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-8i8exb",
"styleBackgroundReadonly": "--awsui-style-background-readonly-8i8exb",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-8i8exb",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-8i8exb",
"styleColorReadonly": "--awsui-style-color-readonly-8i8exb",
"styleBackgroundFocus": "--awsui-style-background-focus-8i8exb",
"styleBorderColorFocus": "--awsui-style-border-color-focus-8i8exb",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-8i8exb",
"styleColorFocus": "--awsui-style-color-focus-8i8exb",
"stylePlaceholderColor": "--awsui-style-placeholder-color-8i8exb",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-8i8exb",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-8i8exb",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-8i8exb",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-8i8exb",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-8i8exb",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-8i8exb",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-8i8exb",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-8i8exb",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-8i8exb",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-8i8exb",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-8i8exb",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-8i8exb",
"alertIconColor": "--awsui-alert-icon-color-8i8exb",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-8i8exb",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-8i8exb",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-8i8exb",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-8i8exb",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-8i8exb",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-8i8exb",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-8i8exb",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-8i8exb",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-8i8exb",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-8i8exb",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-8i8exb",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-8i8exb",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-8i8exb",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-8i8exb",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-8i8exb",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-8i8exb",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-8i8exb",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-8i8exb",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-8i8exb",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-8i8exb",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-8i8exb",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-8i8exb",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-8i8exb",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-8i8exb",
"promptInputMenuStyleBackgroundColor": "--awsui-prompt-input-menu-style-background-color-8i8exb",
"promptInputMenuStyleBorderColor": "--awsui-prompt-input-menu-style-border-color-8i8exb",
"promptInputMenuStyleBorderRadius": "--awsui-prompt-input-menu-style-border-radius-8i8exb",
"promptInputMenuStyleBorderWidth": "--awsui-prompt-input-menu-style-border-width-8i8exb",
"optionBackgroundDefault": "--awsui-option-background-default-8i8exb",
"optionBackgroundHighlighted": "--awsui-option-background-highlighted-8i8exb",
"optionBackgroundSelected": "--awsui-option-background-selected-8i8exb",
"optionColorDefault": "--awsui-option-color-default-8i8exb",
"optionColorHighlighted": "--awsui-option-color-highlighted-8i8exb",
"optionColorDisabled": "--awsui-option-color-disabled-8i8exb",
"optionGroupLabelColor": "--awsui-option-group-label-color-8i8exb",
"optionFilterMatchBackground": "--awsui-option-filter-match-background-8i8exb",
"optionFilterMatchColor": "--awsui-option-filter-match-color-8i8exb",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-8i8exb",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-8i8exb",
"progressBarHeight": "--awsui-progress-bar-height-8i8exb",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-8i8exb",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-8i8exb",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-8i8exb",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-8i8exb",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-8i8exb",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-8i8exb",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-8i8exb",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-8i8exb",
"tokenStyleBackgroundDefault": "--awsui-token-style-background-default-8i8exb",
"tokenStyleBackgroundDisabled": "--awsui-token-style-background-disabled-8i8exb",
"tokenStyleBackgroundReadOnly": "--awsui-token-style-background-read-only-8i8exb",
"tokenStyleBorderColorDefault": "--awsui-token-style-border-color-default-8i8exb",
"tokenStyleBorderColorDisabled": "--awsui-token-style-border-color-disabled-8i8exb",
"tokenStyleBorderColorReadOnly": "--awsui-token-style-border-color-read-only-8i8exb",
"tokenStyleDismissColorDefault": "--awsui-token-style-dismiss-color-default-8i8exb",
"tokenStyleDismissColorDisabled": "--awsui-token-style-dismiss-color-disabled-8i8exb",
"tokenStyleDismissColorHover": "--awsui-token-style-dismiss-color-hover-8i8exb",
"tokenStyleDismissColorReadOnly": "--awsui-token-style-dismiss-color-read-only-8i8exb",
"styleItemCardBackgroundDefault": "--awsui-style-item-card-background-default-8i8exb",
"styleItemCardBorderColorDefault": "--awsui-style-item-card-border-color-default-8i8exb",
"styleItemCardBorderRadius": "--awsui-style-item-card-border-radius-8i8exb",
"styleItemCardBorderWidthDefault": "--awsui-style-item-card-border-width-default-8i8exb",
"styleItemCardBoxShadowDefault": "--awsui-style-item-card-box-shadow-default-8i8exb",
"inlineLabelBackgroundColor": "--awsui-inline-label-background-color-8i8exb",
"containerStyleBorderRadius": "--awsui-container-style-border-radius-8i8exb",
"containerBorderRadius": "--awsui-container-border-radius-8i8exb",
"popoverArrowBorderWidth": "--awsui-popover-arrow-border-width-8i8exb",
      };
      export default customCSSPropertiesMap;
    